'use client';

import { FormRadio as AriakitRadio, useFormContext, useStoreState } from '@ariakit/react';
import cx from 'classnames';

import typographyStyles from '~/ui/styles/typography.module.scss';
import { invariant } from '~/utils/invariant';

import styles from './formRadio.module.scss';

export interface FormRadioProps {
  className?: string;
  name: string;
  value: string;
  label: string;
}

export function FormRadio({
  className,
  name,
  value,
  label,
  ...props
}: FormRadioProps): React.ReactElement {
  const form = useFormContext();
  invariant(form, 'FormRadio must be wrapped in FormProvider');

  const input = useStoreState(form, state => state.values[name]);

  return (
    <div className={cx(className, styles.radio)} {...props}>
      <label
        className={cx(styles.label, typographyStyles.bodySmall, {
          [styles.active]: input === value,
        })}
      >
        <span className={styles.radioMark} />
        <AriakitRadio name={name} value={value} />

        {label}
      </label>
    </div>
  );
}
